import type { ReactNode } from 'react';

export const symbol_mobile_dock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M660-260v-600H301v600h359ZM500-729q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9ZM301-260v-600 600Zm0 60q-24.75 0-42.37-17.63Q241-235.25 241-260v-600q0-24.75 17.63-42.38Q276.25-920 301-920h359q24.75 0 42.38 17.62Q720-884.75 720-860v106q15 2 23.5 14.58T752-711v54q0 16.23-8.5 29.11Q735-615 720-613v353q0 24.75-17.62 42.37Q684.75-200 660-200H301Zm49 150q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h260q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q622.75-50 610-50H350Z"
		/>
	</svg>
);
